import { dashboardPluginService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    dashboard: {
        login_log: [],
        user_data: [],
        admin_data: []
    },
    active_board: 1,
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.dashboard = {
            login_log: [],
                user_data: [],
                admin_data: []
        }
    },
    success(state, dashboard) {
        state.status    = 'success'
        state.dashboard = dashboard
    },
    fail(state) {
        state.status    = 'fail'
        state.dashboard = []
    },
    setBoard(state, value) {
        state.active_board = value
    },
}

const getters = {
    status: state => state.status,
    dashboard: state => state.dashboard
}

const actions = {
    fetchDashboard({commit}) {
        commit('loading')
        return dashboardPluginService.fetchDashboard().then(response => {
            commit('success', response.data.data)
        })
    },
    refreshDashboard({commit}) {
        commit('loading')
        return dashboardPluginService.refreshDashboard().then(response => {
            commit('success', response.data.data)
        })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}